import React, { Component } from 'react';
/** redux **/
import autoBind from 'react-autobind';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as selectors from './redux/reducer';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Card from '../../components/card/cardslide';
import VerticalSlider from '../../components/CardsSlider';
import Loader from '../../components/ProfileLoader';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import '../../components/AlertStyles/Contributor_profile.css';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = {
  cont_container: {
    backgroundColor: '#740d88',
    width: '100%',
    boxSizing: 'border-box',
    maxWidth: '100%',
  },
  profile_name: {
    // marginBottom:'-5px',
    color: 'white',
    marginLeft: 'auto',
    marginRight: 'auto',
    fontSize: '17.1px',
    marginTop: '10px',
    textAlign: 'center',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  avatar_container: {
    textAlign: 'right',
    marginTop: '50px',
    width: '125px',
    height: '125px',
    marginLeft: 'auto',
    marginRight: 'auto',
    border: '2px solid white',
    borderRadius: '100%',
  },
  avatar_pic: {
    width: '113px',
    height: '113px',
    marginTop: '5px',
    marginLeft: 'auto',
    marginRight: 'auto',
    // border:'2px solid white'
  },
  actions: {
    width: '100%',
    color: '#bcbcbc',
    padding: '5px 10px 0px 10px',
    display: 'flex',
    backgroundColor: '#EEB700',
    height: '40px',
    marginTop: '20px',
  },
  actionIcon: {
    backgroundColor: '#bb543e',
    color: 'white',
    margin: '5px',
    // marginTop : "-30px",
    marginBottom: '22px',
    boxShadow: '1px 1px grey',
  },
  pushRight: {
    marginLeft: 'auto',
    marginBottom: '20px',
  },
  event_card: {
    padding: '10px',
    backgroundColor: 'white',
  },
  chip: {
    margin: '10px',
  },
  actionButton: {
    position: 'relative',
    left: '160px',
    top: '-20px',
    paddingLeft: '20px',
    paddingRight: '20px',
    textTransform: 'none',
    backgroundColor: '#c44a33',
    color: 'white',
  },
  eateryTitle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1.48375rem',
    fontWeight: '600',
    lineHeight: '29px',
    letterSpacing: '0px',
  },
  articleBtn: {
    width: 'auto',
    padding: '10px',
    border: '1px solid black',
    borderRadius: '20px',
  },
  profileSec: {
    fontSize: '33.4px',
    color: 'white',
  },
  cityExportBtn: {
    color: 'grey',
    backgroundColor: 'white',
    marginRight: '10px',
  },
  articleBackgroundContainer: {
    backgroundColor: '#eeeae2',
    height: 'auto',
    marginTop: '20px',
    marginBottom: '20px',
    paddingBottom: '20px',
  },
  articleTitle: {
    paddingTop: '20px',
    paddingLeft: '10px',
    marginBottom: '10px',
  },
  contributorStaticText: {
    textAlign: '-webkit-center',
    paddingBottom: '50px',
    paddingTop: '50px',
    backgroundColor: '#FAFAFA',
  },
  categoryContainer: {
    padding: '10px 20px 10px 20px',
    backgroundColor: '#eeb700',
  },
  cityExportContainer: {
    paddingBottom: '0px',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 'auto',
    marginRight: '5%',
  },
  cityExportContainer2: {
    paddingBottom: '0px',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  cityExportChip: {
    marginRight: 'auto',
  },
  cityExportChip2: {
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  cuisineExportContainer: {
    paddingBottom: '0px',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 'auto',
    marginRight: '5%',
  },
  cuisineExportContainer2: {
    paddingBottom: '0px',
    justifyContent: 'center',
    alignContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  cuisineChipContainer: {
    marginRight: 'auto',
  },
  cuisineChipContainer2: {
    marginRight: 'auto',
    marginLeft: 'auto',
  },
  followBtn: {
    backgroundColor: '#c44a33',
    color: 'white',
    top: '50px',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
  textCount: {
    color: 'white',
    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
  },
};
const style = theme => ({
  selectedChip: {
    backgroundColor: theme.palette.primary.main,
    border: '1px solid grey',
    margin: '5px 10px 0px 0px',
    '&:hover': {
      '@media (hover: none)': {
        backgroundColor: theme.palette.primary.main,
      },
    },
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  categoryContainer: {
    padding: '20px 20px 20px 20px',
    backgroundColor: theme.palette.others.bg1,
  },
  chip: {
    border: '1px solid grey',
    margin: '5px 10px 0px 0px',
  },
});

class FollowerButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }
  handleClickOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { id, isFollowing, followLoad, dispatch } = this.props;
    return (
      <Grid container>
        <Grid
          item
          style={{
            marginLeft: 'auto',
            marginTop: '30px',
            marginRight: 'auto',
            marginBottom: '30px',
          }}
        >
          {localStorage.getItem('tsUserInfo') ? (
            <Button
              variant="outlined"
              size="large"
              disabled={followLoad ? true : false}
              style={styles.followBtn}
              onClick={() => {
                isFollowing ? dispatch(actions.unFollow(id)) : dispatch(actions.follow(id))
              }}
            >
              {followLoad ? (isFollowing ? 'Unfollowing ...' : 'Following ...') : (isFollowing ? 'Unfollow' : 'Follow')}
            </Button>
          ) : (
              <div>
                <Button
                  variant="contained"
                  color="secondary"
                  style={styles.followBtn}
                  onClick={this.handleClickOpen}
                >
                  FOLLOW
              </Button>
                <Dialog
                  open={this.state.open}
                  onClose={this.handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">
                    {'Talking Street '}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Please Sign-in or Sign-up to follow Pundits
                  </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={this.handleClose} color="primary" autoFocus>
                      Ok
                  </Button>
                  </DialogActions>
                </Dialog>
              </div>
            )}
        </Grid>
      </Grid>
    );
  }
}

const ContributorProfile = ({ contributorTopData, details, isFollowing, followLoad, dispatch }) => {
  // data is undefined
  if (!details.data) return null;

  let additionalData = details.additionalInfo;
  details = details.data;

  return (
    <React.Fragment>
      <div style={styles.cont_container}>
        <Grid container>
          <Grid item xs={12}>
            <div style={styles.avatar_container}>
              <Avatar
                style={styles.avatar_pic}
                alt="user_pic"
                src={
                  details.profilePic === null
                    ? '/icons/user.png'
                    : details.profilePic.uri
                }
              />
            </div>
            <h3 style={styles.profile_name}>
              {details.name ? details.name : details.displayName}
            </h3>
          </Grid>
        </Grid>

        <Grid container spacing={24}>
          <Grid
            item
            className="cityExportContainer"
            style={{
              paddingBottom: '0px',
              justifyContent: 'center',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            {details.citiesOfExpertise &&
              details.citiesOfExpertise.length > 0 ? (
                <span
                  style={{
                    color: 'white',
                    fontSize: '13px',
                    paddingLeft: '3px',
                    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
                  }}
                >
                  City Expert
              </span>
              ) : null}
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={24}>
          <Grid
            item
            lg="auto"
            md={12}
            style={{ marginLeft: 'auto', marginRight: 'auto', lineHeight: 2.5 }}
          >
            {details.citiesOfExpertise.slice(0, 4).map((v, id) => {
              return (
                <Chip
                  label={v.name}
                  key={id}
                  style={styles.cityExportBtn}
                  variant="outlined"
                />
              );
            })}
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={24}>
          <Grid
            item
            style={{
              // textAlign: 'left',
              paddingBottom: '0px',
              justifyContent: 'center',
              alignContent: 'center',
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            {details.cuisinesOfExpertise &&
              details.cuisinesOfExpertise.length > 0 ? (
                <span
                  style={{
                    color: 'white',
                    fontSize: '13px',
                    // paddingRight: '32px',
                    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
                  }}
                >
                  Cuisine Expert
              </span>
              ) : null}
          </Grid>
        </Grid>
        <br />
        <Grid container spacing={24}>
          <Grid
            item
            // sm={4}
            lg="auto"
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              lineHeight: 2.5,
              maxWidth: 'max-content',
            }}
          >
            {details.cuisinesOfExpertise.slice(0, 4).map((cuv, id) => {
              return (
                <Chip
                  label={cuv.name}
                  style={{
                    color: 'grey',
                    backgroundColor: 'white',
                    // padding: '2px 0 2px 0',
                    marginRight: '5px',
                  }}
                  variant="outlined"
                  key={id}
                />
              );
            })}
          </Grid>
        </Grid>
        <br />
        <br />
        <Grid container spacing={8}>
          <Grid item xs={4} style={{ textAlign: 'center' }}>
            <span style={styles.profileSec}>
              {additionalData['total.authored']}
            </span>
            <br />
            <span style={styles.textCount}>Articles</span>
          </Grid>
          <Grid item xs={4} style={{ textAlign: 'center' }}>
            <span style={styles.profileSec}>
              {additionalData['boost.count']}
            </span>
            <br />
            <span style={styles.textCount}>Followers</span>
          </Grid>
          <Grid item xs={4} style={{ textAlign: 'center' }}>
            <span style={styles.profileSec}>
              {additionalData['boost.count']}
            </span>
            <br />
            <span style={styles.textCount}>Applause</span>
          </Grid>
        </Grid>
        <FollowerButton dispatch={dispatch} isFollowing={isFollowing} followLoad={followLoad} id={details.id} />
      </div>
      <Grid container style={{ backgroundColor: '#eeeae2' }}>
        <Grid
          item
          xs={12}
          style={{
            textAlign: '-webkit-center',
            marginTop: '50px',
            marginBottom: '50px',
          }}
        >
          <Typography
            variant="body2"
            component="p"
            style={{
              lineHeight: '1.5',
              paddingLeft: '10px',
              paddingRight: '10px',
            }}
          >
            {details.userProfile.bio ? details.userProfile.bio : null}
          </Typography>
        </Grid>
      </Grid>

      <Grid
        container
        style={{ backgroundColor: '#eeeae2', paddingBottom: '50px' }}
      >
        {contributorTopData.length > 0 ? (
          <Grid item xs={12}>
            {details.name === '' || details.name === null ? (
              <p style={{ textAlign: 'left', paddingLeft: '10px' }}>
                {details.displayName.toUpperCase()}'S TOP 5
              </p>
            ) : (
                <p
                  style={{
                    textAlign: 'left',
                    paddingLeft: '10px',
                    fontFamily: 'Catamaran, Roboto, Helvetica, Arial, sans-serif',
                  }}
                >
                  {details.name.toUpperCase()}'S TOP 5
              </p>
              )}
            {contributorTopData.length > 0 ? (
              <div style={{ padding: '10px' }}>
                <Card
                  cards={contributorTopData}
                  noslider={false}
                />
              </div>
            ) : (
                ''
              )}
          </Grid>
        ) : (
            ''
          )}
      </Grid>

      <Grid container>
        <Grid item xs={12} style={styles.contributorStaticText}>
          <Typography variant="body2" component="p" gutterBottom>
            The contributors well known for a cuisine or city are the experts.
            They have explored the city/ cuisine inside-out through a food lens
            making them the masters at it.
          </Typography>
        </Grid>
      </Grid>
      <Grid container style={{ backgroundColor: '#FAFAFA' }}>
        <Grid item xs={12}>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

const CountContainer = ({ classes, results, category, onCatChange }) => {
  var stories = [],
    eateries = [],
    listicles = [],
    experiences = [];
  results.forEach(result => {
    switch (result.resourceType) {
      case 'LISTICLE':
        listicles.push(result);
        return 0;
      case 'EATERY':
        eateries.push(result);
        return 0;
      case 'STORY':
        stories.push(result);
        return 0;
      case 'EXPERIENCE':
        experiences.push(result);
        return 0;
      default:
        return 0;
    }
  });
  return (
    <div className={classes.categoryContainer}>
      <Typography variant="body2">ARTICLES</Typography>
      {results.length > 0 ? (
        <Chip
          label={'All ' + results.length}
          onClick={() => onCatChange('ALL')}
          className={category === 'ALL' ? classes.selectedChip : classes.chip}
        />
      ) : (
          ''
        )}

      {eateries.length > 0 ? (
        <Chip
          label={'Eateries ' + eateries.length}
          onClick={() => onCatChange('EATERY')}
          className={
            category === 'EATERY' ? classes.selectedChip : classes.chip
          }
        />
      ) : (
          ''
        )}

      {stories.length > 0 ? (
        <Chip
          label={'Stories ' + stories.length}
          onClick={e => {
            e.preventDefault();
            onCatChange('STORY');
          }}
          className={category === 'STORY' ? classes.selectedChip : classes.chip}
        />
      ) : (
          ''
        )}

      {experiences.length > 0 ? (
        <Chip
          label={'Experiences ' + experiences.length}
          onClick={() => onCatChange('EXPERIENCE')}
          className={
            category === 'EXPERIENCE' ? classes.selectedChip : classes.chip
          }
        />
      ) : (
          ''
        )}

      {listicles.length > 0 ? (
        <Chip
          label={'Listicles ' + listicles.length}
          onClick={() => onCatChange('LISTICLE')}
          className={
            category === 'LISTICLE' ? classes.selectedChip : classes.chip
          }
        />
      ) : (
          ''
        )}
    </div>
  );
};

class ContributorExperiencePage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  state = {
    category: 'ALL',
    defaultSelectedView: 'ALL',
    displayResults: this.props.contributorExpData,
    activeFilterCount: 0,
  };
  componentDidMount() {
    let id = this.props.match.params.contributor_id;
    this.props.dispatch(actions.getContributorProfileDetails(id));
  }

  handleCatChange(category) {
    let newResults = [];
    if (category === 'ALL') newResults = this.props.contributorExpData;
    else {
      this.props.contributorExpData.forEach(result => {
        if (result.resourceType === category) {
          newResults.push(result);
        }
      });
    }
    this.setState({
      category: category,
      displayResults: newResults,
      activeFilterCount: this.state.activeFilterCount + 1,
    });
  }

  render() {
    const {
      contributorExpData,
      contributorData,
      loading,
      classes,
      isFollowing,
      followLoad
    } = this.props;

    if (loading) {
      return <Loader loadingText="TS food pundit profile coming up..." />;
    } else {
      return (
        <div style={{ overflowX: 'hidden' }}>
          <ContributorProfile
            contributorTopData={contributorData.contributorTopData}
            details={contributorData.contributorData}
            isFollowing={isFollowing}
            followLoad={followLoad}
            dispatch={this.props.dispatch}
          />

          <CountContainer
            onCatChange={this.handleCatChange}
            category={this.state.category}
            results={contributorExpData}
            classes={classes}
          />
          <br />
          {loading ? (
            <Loader loadingText="TS food pundit profile coming up..." />
          ) : (
              <VerticalSlider noslider={true} cards={this.state.displayResults} />
            )}
          <br />
          {this.state.activeFilterCount === 0 ? (
            <VerticalSlider noslider={true} cards={contributorExpData} />
          ) : (
              ''
            )}
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    loading: selectors.getValue(state, 'loading'),
    contributorExpData: selectors.getValue(state, 'contributorExpData'),
    contributorData: selectors.getAllValues(state, ' contributorExpData'),
    contributorTops: selectors.getAllValues(state, 'contributorExpData'),
    isFollowing: selectors.getValue(state, 'isFollowing'),
    followLoad: selectors.getValue(state, 'followLoad')
  };
}
export default connect(mapStateToProps)(
  withStyles(style)(ContributorExperiencePage)
);
